<template>
  <div class="card-map">
    <HdLoadingSpinner v-if="isLoading" />
    <iframe
      :src="src"
      class="card-map__iframe"
      loading="lazy"
      title="map"
      @load="handleIframeLoad()"
    />
  </div>
</template>

<script>
import HdLoadingSpinner from '@/components/HdLoadingSpinner.vue';

export default {
  name: 'CardMap',
  components: { HdLoadingSpinner },
  props: {
    deal: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isLoading: true,
    };
  },
  computed: {
    src() {
      const address = this.deal.property.address.formatted_address;
      const encodedAddress = encodeURIComponent(address);
      return `https://www.google.com/maps/embed/v1/place?key=${process.env.VUE_APP_GOOGLE_MAPS_API_KEY}&q=${encodedAddress}`;
    },
  },
  methods: {
    handleIframeLoad() {
      this.isLoading = false;
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/styles/mixins.scss';

.card-map {
  min-height: 80px;
  position: relative;

  &__iframe {
    border-radius: $sp-m - $sp-xxs;
    width: 100%;
  }

  ::v-deep > svg {
    left: calc(50% - 22px);
    position: absolute;
    top: calc(50% - 22px);
  }
}
</style>
